import { StatusDot } from '@/components/primitives/StatusDot';

export type Dt3pConnectionStatus = 'connected' | 'not_connected' | 'not_provisioned';

export function computeDt3pConnectionStatus(
  externalId: string | null | undefined,
  heartbeatMap: Record<string, true> | undefined,
): Dt3pConnectionStatus {
  if (!externalId) return 'not_provisioned';
  if (heartbeatMap?.[externalId]) return 'connected';
  return 'not_connected';
}

export function Dt3pHealthContent({ status }: { status: Dt3pConnectionStatus }) {
  let variant: 'success' | 'error' | undefined;
  let label: string;

  switch (status) {
    case 'connected':
      variant = 'success';
      label = 'Connected';
      break;
    case 'not_connected':
      variant = 'error';
      label = 'Not Connected';
      break;
    case 'not_provisioned':
      variant = undefined;
      label = 'Not Provisioned';
      break;
  }

  return (
    <span className="flex items-center gap-2 whitespace-nowrap">
      <StatusDot variant={variant} />
      {label}
    </span>
  );
}
